const styles = {
    exclude: {
        color: 'rgba(0, 0, 0, 0.45)'
    }
}

export default styles;